<template>
  <div>
    <h1 class="title">{{ title }}</h1>
    <p class="subtitle" v-if="subtitle">{{ subtitle }}</p>
    <p class="error" v-if="code && message">{{ code }} - {{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "PageError",
  data: () => ({
    message: "Unexpected error",
    code: ""
  }),
  props: {
    title: {
      type: String,
      default: "Error"
    },
    error: {
      type: Error,
      default: null
    },
    subtitle: {
      type: String,
      default: ""
    }
  },
  created() {
    if (this.error) {
      let errorMsg = this.error.response;
      this.code = errorMsg.status ? errorMsg.status : "";
      this.message = errorMsg.data ? errorMsg.data : "";
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 300px;
  text-align: center;
  color: #d6d6d6;
  margin: 40px 0 0;
}
.error {
  text-align: center;
  font-size: 1.6rem;
  max-width: 800px;
  margin: 0 auto;
  color: #dc0000;
}
.subtitle {
  text-align: center;
  font-size: 3rem;
  max-width: 800px;
  margin: 0 auto;
  color: #dc0000;
}
</style>
